
import Vue from 'vue';
import Component from 'vue-class-component';
import ConfirmationModel from '../ConfirmationModel';
import { Prop } from 'vue-property-decorator';

@Component
export default class ConfirmDelete extends Vue {
    @Prop({
        type: ConfirmationModel,
        required: true,
    })
    public confirmationModel!: ConfirmationModel;
    public message: string = '';
    public dialogOpen: boolean = false;

    public get isFolderDelete() {
        return this.message === 'Czy usunąć ten folder?' || this.message === 'Czy chcesz usunąć folder?';
    }

    public mounted() {
        this.confirmationModel.on('confirm', (message: string) => {
            this.dialogOpen = true;
            this.message = message;
        });
    }
}

export { ConfirmationModel };
